import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Avatar from 'flarum/common/components/Avatar';
import Dropdown from 'flarum/common/components/Dropdown';
import Icon from 'flarum/common/components/Icon';
import Link from 'flarum/common/components/Link';
import listItems from 'flarum/common/helpers/listItems';
import username from 'flarum/common/helpers/username';
import ItemList from 'flarum/common/utils/ItemList';
import UserControls from 'flarum/forum/utils/UserControls';
// "14 oct. 2005" - same format as a post's date (champis-forum's
// showPostDateTime.tsx), with core's global `dayjs` (French locale), not
// an imported copy.
function formatDate(date) {
  return dayjs(date).format('DD MMM YYYY');
}

// "champignons-geneve.ch" rather than the whole URL, which can be long.
function websiteLabel(url) {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
}
function externalLink(url, label) {
  return m("a", {
    href: url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, label);
}

/**
 * One member of the member list (fof/user-directory's /users page, see
 * addMemberList.tsx): a row, like phpBB's member list, instead of that
 * extension's profile cards - avatar, name, group badges (but Members')
 * and real name, a muted line below with the joined date, last visit,
 * location, website and associations (each only when there is one), and
 * the post count on the right. The moderation menu stays, for those who have one.
 */
export default class MemberRow extends Component {
  view() {
    const user = this.attrs.user;
    const href = app.route.user(user);
    const badges = user.badges();
    const fullName = [user.champisFirstName(), user.champisLastName()].filter(Boolean).join(' ');
    const controls = UserControls.controls(user, this).toArray();
    return m("div", {
      className: "ChampisMemberRow"
    }, m(Link, {
      href: href,
      className: "ChampisMemberRow-avatar",
      tabindex: "-1",
      "aria-hidden": "true"
    }, m(Avatar, {
      user: user
    })), m("div", {
      className: "ChampisMemberRow-main"
    }, m("div", {
      className: "ChampisMemberRow-header"
    }, m(Link, {
      href: href,
      className: "ChampisMemberRow-name"
    }, username(user)), badges.isEmpty() ? null : m("ul", {
      className: "ChampisMemberRow-badges badges"
    }, listItems(badges.toArray())), fullName ? m("span", {
      className: "ChampisMemberRow-fullName"
    }, fullName) : null), m("ul", {
      className: "ChampisMemberRow-info"
    }, listItems(this.infoItems().toArray()))), m("div", {
      className: "ChampisMemberRow-posts"
    }, app.translator.trans('champis-users.forum.member_list.post_count', {
      count: user.commentCount() ?? 0
    })), controls.length ? m(Dropdown, {
      className: "ChampisMemberRow-controls",
      menuClassName: "Dropdown-menu--right",
      buttonClassName: "Button Button--icon Button--flat",
      label: app.translator.trans('core.forum.user_controls.button'),
      accessibleToggleLabel: app.translator.trans('core.forum.user_controls.toggle_dropdown_accessible_label'),
      icon: "fas fa-ellipsis-v"
    }, controls) : null);
  }
  infoItems() {
    const items = new ItemList();
    const user = this.attrs.user;
    const joinTime = user.joinTime();
    // Only there for members who show their online status (core's
    // "discloseOnline" setting) - or to moderators.
    const lastSeenAt = user.lastSeenAt();
    const website = user.champisWebsite();
    const associations = user.champisAssociations() || [];
    if (joinTime) {
      items.add('joined', app.translator.trans('champis-users.forum.member_list.joined_text', {
        date: formatDate(joinTime)
      }), 100);
    }
    if (lastSeenAt) {
      items.add('lastSeen', user.isOnline() ? m("span", {
        className: "ChampisMemberRow-online"
      }, m(Icon, {
        name: "fas fa-circle",
        noStyleOverride: true
      }), " ", app.translator.trans('core.forum.user.online_text')) : app.translator.trans('champis-users.forum.member_list.last_seen_text', {
        date: formatDate(lastSeenAt)
      }), 90);
    }
    if (user.champisLocation()) {
      items.add('location', m("span", null, m(Icon, {
        name: "fas fa-map-marker-alt"
      }), " ", user.champisLocation()), 70);
    }
    if (website) {
      items.add('website', m("span", null, m(Icon, {
        name: "fas fa-globe"
      }), " ", externalLink(website, websiteLabel(website))), 60);
    }
    if (associations.length) {
      items.add('associations', m("span", null, m(Icon, {
        name: "fas fa-users"
      }), ' ', associations.map((association, index) => [index ? ', ' : '', association.url ? externalLink(association.url, association.name || websiteLabel(association.url)) : association.name])), 50);
    }
    return items;
  }
}
flarum.reg.add('champis-users', 'forum/components/MemberRow', MemberRow);